import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { Panel } from '../../../common/panel'
import { CreateProfile } from './CreateProfile'
import classes from './index.module.scss'
import { ProfileTable } from './ProfileTable'

export const CompanyAlert = () => {
  return (
    <Panel label="alertSetting.COMPANY_ALERTS" isI18n>
      <Element
        className={classes.note}
        style={{ color: '#3A414B', borderBottomColor: '#B5CEF8' }}
      >
        <Translate value="alertSetting.COMPANY_ALERT_NOTE" />
      </Element>

      <CreateProfile />

      <ProfileTable />
    </Panel>
  )
}
